module.exports = __webpack_public_path__ + "static/img/6-2.1a27c13.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/6-2.png
// module id = DRm2
// module chunks = 0